import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tabs, Tab } from '@mui/material';

import HeadingRow from '../../Dashboard/components/HeadingRow';

import AddButton from '../../../Components/AddButton';

import { useListing } from '../../../hooks/useListing';
import endPoints from '../../../api/endpoint';
import { TabProps } from '../../../Utils/helperFns';

import { ROUTES } from '../../../helpers/contants';

import {
  removeBreadCrumbs,
  setBreadCrumbs,
  setSelectedEntity,
  setSelectedEntityType,
  updatePaginationPage,
} from '../../../redux/commonSlice';
import { useDispatch } from 'react-redux';
import Productions from './Productions';

const ProductionList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isTabular, setIsTabular] = useState<boolean>(false);
  const [value, setValue] = useState<number>(0);
  const [searchKey, setSearchKey] = useState<any>('');
  const [countData, setCountData] = useState<any>({});
  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 8,
    searchKey: '',
    status: 'ACTIVE',
  });

  const {
    fetchListing,
    data: favorites,
    hasMore,
    loading,
    setData,
    count,
    setLoading,
  } = useListing<any>({
    url: endPoints.production.productionDashList,
    params: {
      ...filter,
    },
    isProduction: true,
    isInfinite: !isTabular,
    setCountData: setCountData,
  });

  useEffect(() => {
    fetchListing();
  }, [filter]);

  const handleDetailRedirection = (entityData: any) => {
    removeBreadCrumbs();
    dispatch(setSelectedEntity(entityData));
    dispatch(setSelectedEntityType('production'));
    const data = [
      {
        current: 0,
        name: 'prodcution',
        type: 'dashboard',
        title: entityData?.name,
        path: `${ROUTES.PRODUCTION_DASHBOARD}?${entityData?._id}`,
        selectedEntity: entityData,
      },
    ];

    setBreadCrumbs(data);
    navigate(`${ROUTES.PRODUCTION_DASHBOARD}?${entityData?._id}`);
  };

  const loadMore = () => {
    if (!loading && hasMore) {
      setFilter({
        ...filter,
        page: filter.page + 1,
      });
    }
  };
  const tabKeys = ['ACTIVE', 'INACTIVE', 'COMPLETED', 0];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setLoading(true);
    // dispatch(setTabValue(newValue))
    // setSelectedTab(tabKeys[newValue])
    setData([]);
    setFilter({
      ...filter,
      status: tabKeys[newValue],
      page: 1,
    });
    updatePaginationPage(1);
  };
  useEffect(() => {
    updatePaginationPage(1);
  }, []);

  return (
    <section className="all-episodes">
      <HeadingRow
        title={`My Projects/Live Events`}
        isTabular={isTabular}
        setIsTabular={setIsTabular}
        onSearch={(value: string) => {
          setFilter({
            ...filter,
            searchKey: value.trim(),
            page: 1,
          });
        }}
        handleClearSearch={() => {
          setFilter({
            ...filter,
            searchKey: '',
            page: 1,
          });
        }}
        isShowButton={false}
        isManage
        setFilter={() => {
          setFilter({
            ...filter,
            searchKey: '',
            page: 1,
          });
        }}
        setData={setData}
        isShowViewBtn
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchPlaceholder="Search My Projects..."
        // isShowAddEpisodeButton
        // type={'productions'}
      />

      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        variant="scrollable"
        centered
        scrollButtons={false}
        allowScrollButtonsMobile
        className="mb-24"
      >
        <Tab
          label={`Active(${countData?.activeCount || 0})`}
          {...TabProps(0)}
        />
        <Tab
          label={`Upcoming(${countData?.inactiveCount || 0}) `}
          {...TabProps(1)}
        />

        <Tab
          label={`Completed(${countData?.completedCount || 0})`}
          {...TabProps(2)}
        />

        <Tab
          label={`All(${countData?.totalProductionCount || 0})`}
          {...TabProps(3)}
        />
      </Tabs>

      <Productions
        isTabular={isTabular}
        setFilter={setFilter}
        filter={filter}
        favorites={favorites}
        count={count}
        navigate={navigate}
        loadMore={loadMore}
        loading={loading}
        hasMore={hasMore}
        handleDetailRedirection={handleDetailRedirection}
        showLocationCount={true}
        allowEditOnScreen={true}
      />
      <AddButton />
    </section>
  );
};

export default ProductionList;
